/**
 * 车辆维修实体
 * * zxw
 * 创建时间：
 * 修改时间：2026-07-09
*/

import { useState, useEffect } from 'react';
import {
    Modal,
    Input,
    Row,
    Col,
    message,
    InputNumber,
    Select,
    DatePicker,
    Flex,
    Typography,
} from 'antd';
import $ from 'jquery';
import {
    AddRequestHeaders,
    UjoinParams,
    currentDate,
} from '../../incs/FunHelper';
import CNF from '../../incs/Config';

/** 
* 日期样式
*/
import dayjs from 'dayjs';
const MODULENAME = '车辆维修';

const { TextArea } = Input;
const { Text } = Typography;

const MODULENAME_URL = CNF.navItems[1].submenu[1].url;

const Entity = (props) => {
    const { open, setOpen, record, refresh, carLists } = props;
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [carUlid, setCarUlid] = useState('');
    const [time, setTime] = useState(currentDate);
    const [applyUsername, setApplyUsername] = useState('');
    const [applyDisplayname, setApplyDisplayname] = useState('');
    const [amount, setAmount] = useState(0.00);
    const [type, setType] = useState('');
    const [detail, setDetail] = useState('');
    const [repairFactory, setRepairFactory] = useState('');
    const [faultDescription, setFaultDescription] = useState('');
    const [faultCause, setFaultCause] = useState('');

    // 人员列表
    const [personnelLists, setPersonnelLists] = useState([]);

    const cancel = () => {
        setOpen(false);
        setLoading(false);
        setCarUlid('');
        setTime(currentDate);
        setApplyUsername('');
        setApplyDisplayname('');
        setAmount(0.00);
        setType('');
        setDetail('');
        setRepairFactory('');
        setFaultCause('');
        setFaultDescription('');
    };

    useEffect(() => {
        // 修改初始化
        if (record) {
            console.log(record);
            setCarUlid(record.car_ulid);
            setTime(record.time);
            setApplyUsername(record.apply_username);
            setApplyDisplayname(record.apply_displayname);
            setAmount(record.amount);
            setType(record.type);
            setDetail(record.detail);
            setRepairFactory(record.repair_factory);
            setFaultCause(record.fault_cause);
            setFaultDescription(record.fault_description);
        }
    }, [record]);

    useEffect(() => {
        const params = {
            rss: 'list',
            page_size: CNF.maxPageSize,
            current_index: 1
        };
        $.ajax({
            url: `${CNF.sealApi}users${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            crossDomain: true,
            type: 'GET',
        }).done((data) => {
            if (data.res === 0) {
                setPersonnelLists(data.dat);
            } else {
                setPersonnelLists([])
            }
        })
    }, [])

    const ok = () => {
        //  参数校验
        if (!carUlid) {
            messageApi.error('车牌号码不能为空！');
            return;
        }
        if (!type) {
            messageApi.error('维修类型不能为空！');
            return;
        }
        if (!time) {
            messageApi.error('维修时间不能为空！');
            return;
        }
        if (!applyUsername || !applyDisplayname) {
            messageApi.error('申请人员不能为空！');
            return;
        }
        if (!repairFactory) {
            messageApi.error('申请人员不能为空！');
            return;
        }
        if (!detail) {
            messageApi.error('维修明细不能为空！');
            return;
        }
        // if (!faultDescription) {
        //     messageApi.error('故障描述不能为空！');
        //     return;
        // }
        // if (!faultCause) {
        //     messageApi.error('故障原因不能为空！');
        //     return;
        // }

        setLoading(true);

        $.ajax({
            url: CNF.api + MODULENAME_URL.slice(1) + (props.record ? '/' + props.record.key : ''),
            headers: AddRequestHeaders(),
            type: props.record ? 'PUT' : 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                car_ulid: carUlid,
                time: time,
                apply_username: applyUsername,
                apply_displayname: applyDisplayname,
                amount: amount,
                type: type,
                detail: detail,
                repair_factory: repairFactory,
                fault_description: faultDescription,
                fault_cause: faultCause,
            })
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    refresh();
                }, CNF.messageDuration * 1000);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (err) {
            messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
        }).always(() => setTimeout(function () {
            setLoading(false)
        }, CNF.messageDuration * 1000))
    };


    return (
        <>
            {contextHolder}
            <Modal
                style={{ top: 0 }}
                width={600}
                title={(record ? CNF.actionName.UPDATE : CNF.actionName.CREATE) + MODULENAME}
                open={open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ disabled: loading }}
            >
                <Flex vertical gap='small'>
                    <Row>
                        <Col span={11}><Text>车牌号码</Text><Text type='danger'>*</Text></Col>
                        <Col span={11} offset={2}><Text>维修类型</Text><Text type='danger'>*</Text></Col>
                        <Col span={11}>
                            <Select
                                showSearch
                                placeholder='请选择'
                                style={{ width: '100%' }}
                                value={carUlid || undefined}
                                onChange={(value) => setCarUlid(value)}
                                disabled={loading}
                                filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                                options={carLists && carLists.map((item, index) => ({
                                    key: index,
                                    value: item.key,
                                    label: item.license_number,
                                }))}
                            />
                        </Col>
                        <Col span={11} offset={2}>
                            <Select
                                placeholder='请选择'
                                style={{ width: '100%' }}
                                value={type || undefined}
                                onChange={(value) => setType(value)}
                                options={CNF.repairTypes && CNF.repairTypes.map((item, index) => ({
                                    key: index,
                                    value: item.value,
                                    label: item.key,
                                }))}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={11}><Text>维修时间</Text><Text type='danger'>*</Text></Col>
                        <Col span={11} offset={2}><Text>维修金额</Text></Col>
                        <Col span={11}>
                            <DatePicker
                                placeholder='请选择日期'
                                style={{ width: '100%' }}
                                value={dayjs(time, 'YYYY-MM-DD')}
                                onChange={(_, dateString) => setTime(dateString)}
                                disabled={loading}
                            />
                        </Col>

                        <Col span={11} offset={2}>
                            <InputNumber
                                style={{ width: '100%' }}
                                formatter={value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                min={0}
                                step='0.01'
                                value={amount}
                                onChange={(value) => setAmount(value)}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={11}><Text>申请人员</Text><Text type='danger'>*</Text></Col>
                        <Col span={11} offset={2}><Text>维修厂家</Text><Text type='danger'>*</Text></Col>
                        <Col span={11}>
                            <Select
                                showSearch
                                placeholder='请选择'
                                style={{ width: '100%' }}
                                value={applyUsername || undefined}
                                onChange={(value, option) => {
                                    setApplyUsername(value);
                                    setApplyDisplayname(option?.label || '');
                                }}
                                disabled={loading}
                                filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                                options={personnelLists && personnelLists.map((item, index) => ({
                                    key: index,
                                    value: item.username,
                                    label: item.displayname,
                                }))}
                            />
                        </Col>
                        <Col span={11} offset={2}>
                            <Input
                                placeholder='请输入'
                                value={repairFactory}
                                onChange={(e) => setRepairFactory(e.target.value)}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}><Text>维修明细</Text><Text type='danger'>*</Text></Col>
                        <Col span={24}>
                            <TextArea
                                placeholder='请输入'
                                autoSize={{ minRows: 2, maxRows: 3 }}
                                value={detail}
                                onChange={(e) => setDetail(e.target.value)}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}><Text>故障描述</Text></Col>
                        <Col span={24}>
                            <TextArea
                                placeholder='请输入'
                                autoSize={{ minRows: 2, maxRows: 3 }}
                                value={faultDescription}
                                onChange={(e) => setFaultDescription(e.target.value)}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}><Text>故障原因</Text></Col>
                        <Col span={24}>
                            <TextArea
                                placeholder='请输入'
                                autoSize={{ minRows: 2, maxRows: 3 }}
                                value={faultCause}
                                onChange={(e) => setFaultCause(e.target.value)}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                </Flex>
            </Modal>
        </>
    );
}

export default Entity